const JobsData = [
    {
      id: 1,
      role: "Automation Test Developer",
      location: "Remote",
      jd:[
        {
          label:'Top Requirements:',
          list:[
            'Typescript development experience OR',
            'Experience writing test cases with open-source testing tools such as Cucumber',
            'Prior experience developing automation for testing'
          ]
        },
        {
          label:'Job Breakout:',
          list:[
            'Team is responsible for UAT of all our new development. Need someone to help run UAT and develop all of the automated testing. So, some really high-level requirements:',
            'We need someone with automated test development experience. We use TypeScript and Cucumber.'
          ]
        }
      ]
    },
    {
      id: 2,
      role: "Network/Wifi Engineer",
      location: "Remote",
      jd:[
        {
          label:'Job Description:',
          list:[
            'Our enterprise client in Greenwood Village is looking for network engineers with prior lab experience. The right candidate for this role will have experience working in a lab writing and executing test scripts for devices. In this role, you will be testing WiFi functionality through routers and modems in the lab environment. Ideally, this person will have some exposure to 802.11/WiFi, but it is not necessary. This candidate should have basic understanding of networking protocols (IPV4, IPV6, DNS, DHCP, etc). This role is going to be primarily onsite for the beginning of the role, and then will move to a hybrid model.'
          ]
        },
        {
          label:'Qualifications:',
          list:[
            'Hardware Product Testing Experience (preferably wi-fi products, but others are ok if they worked on testing them within a lab)'
          ]
        },
        {
          label:'Test scripting experience:',
          list:[
            'Lab Experience (even minimal lab experience is okay, as long as they are comfortable working in a lab)',
            'Network Experience (IPV4, IPV6, DNS, DHCP, etc).'
          ]
        },
        {
          label:'Bonus Experience',
          list:[
            'RF Experience',
            'WiFi/802.11 Experience'
          ]
        }
      ]
    },
    {
      id: 3,
      role: "Senior Java Developer",
      location: "Remote",
      jd:[
        {
          label:'Requirements:',
          list:[
            '6+ years’ experience developing software with Java 8 or higher (team uses Java 8 and Java 11)',
            '3+ years’ experience with building APIs and developing restful web services (REST, SOAP)',
            'Strong experience working in an AWS environment and understanding of Scrum/Agile development methodologies'
          ]
        },
        {
          label:'Plusses:',
          list:[
            'Strong understanding of infrastructure automation technologies (Docker, Kubernetes) Experience with scripting languages (Perl, Shell)',
            'Strong understanding with monitoring technologies (Splunk, DataDog)',
            'Strong understanding with infrastructure automation technologies (Docker, Kubernetes)',
            'Experience with yaml, shell scripting, python, git, maven, Intellij, AWS, Jira, SpringBoot'
          ]
        },
        {
          label:'Day to Day/Project:',
          list:[
            'This role will focus on various aspects of the API Gateway and Identity Provider platform (authentication and authorization). Overall, the expectations are to develop, modify, enhance, and implement software systems designed to support business initiatives. Projects are usually of moderate complexity, and require solid knowledge of development technologies and tools. The Software Engineer works in most phases of a project including but not limited to, design, programming, integration, dev test, and release; performs maintenance, and provides technical assistance/advice on existing software solutions.'
          ]
        },
        {
          label:'Job Summary:',
          list:[
            'The Shared Services Team within Charter is seeking a passionate, results-oriented, and innovative senior software engineer. The successful candidate needs to have a proven software development methodology background with experience in Java 8 and 11, and Spring Boot being a plus. A commitment to collaborative problem solving and quality products is essential. Expect to think outside the box, solve real problems, and change how technology is used in our company. We work in a Scrum environment where it’s every team member’s responsibility to ensure SDLC best practices are followed. This role will focus on various aspects of the API Gateway and Identity Provider platform (authentication and authorization).',
            'Overall, the expectations are to develop, modify, enhance, and implement software systems designed to support business initiatives. Projects are usually of moderate complexity, and require solid knowledge of development technologies and tools. The Software Engineer works in most phases of a project including but not limited to, design, programming, integration, dev test, and release; performs maintenance, and provides technical assistance/advice on existing software solutions.'
          ]
        },
        {
          label:'MAJOR DUTIES AND RESPONSIBILITIES:',
          list:[
            'Actively and consistently supports all efforts to simplify and enhance the customer experience.',
            'Code and perform unit and integration testing of software to ensure proper and efficient execution while adhering to business and technical requirements',
            'Code, test, debug, and enhance software',
            'Write programs according to specifications',
            'Participate in code review sessions to validate adherence with development standards',
            'Develop and maintain technical documentation',
            'Serve as an escalation point to resolve incidents and problems with software supported by the team',
            'Generate reports and/or data through database management, data administration, and data extraction techniques',
            'Provide system analysis and improvement recommendations',
            'Identify and recommend system designs/requirements for software enhancements with senior team members',
            'Implement, monitor, test, and audit new software programs to maximize efficiency of software systems',
            'Participate in continuous performance improvement sessions to discuss opportunities to improve processes and/or standards',
            'Coordinate with technical teams to analyze and resolve software related problems causing operational difficulties, advising on specialized features and functions',
            'Follow established configuration/change control processes',
            'Work with team to evaluate workload'
          ]
        },
        {
          label:'REQUIRED QUALIFICATIONS:',
          list:[
            'Ability to read, write, speak and understand English',
            'Expertise in Java (8 and 11)',
            'Experience with open source technologies',
            'Experience with test-driven development and automated testing frameworks',
            'Strong understanding of Scrum/Agile development methodologies',
            'Capable of delivering on multiple competing priorities with little supervision',
            'Strong understanding with infrastructure automation technologies (Docker, Kubernetes)',
            'Strong understanding of build automation technologies (Gitlab)',
            'Strong understanding with monitoring technologies (Splunk, DataDog)',
            'Strong experience with building APIs and services using prevailing design models (REST, SOAP)',
            'Experience with scripting languages (Perl, Shell)',
            'Experience with software security principles and patterns',
            'Experience with AWS'
          ]
        },
        {
          label:'Education:',
          list:[
            'BA/BS in Information Technology, Computer Science, or related field or equivalent work experience'
          ]
        },
        {
          label:'Related Work Experience:',
          list:[
            '6 plus years experience developing software with Java 8 or higher',
            '6 plus years experience with software development methodologies',
            '3 plus years experience developing restful web services',
            'Experience with docker and kubernetes',
            'Experience developing CI/CD toolkits and pipelines',
            'Familiarity with service mesh (Istio or Kuma/Envoy)',
            'Familiarity with Unix and MacOS',
            'Experience with yaml, shell scripting, python, git, maven, Intellij, AWS, Jira',
            'Experience/familiarity developing containerized microservices',
            'Familiarity with basic networking concepts is highly desirable'
          ]
        },
      ]
    },
    {
      id: 4,
      role: "Salesforce Administrator",
      location: "Remote",
      jd:[
        {
          label:'Responsibilities:',
          list:[
            'As a Salesforce Administrator, this individual will work with different internal teams and external vendors to provide the highest standards of Administration & Support Salesforce Applications.'
          ]
        },
        {
          label:'Job Duties:',
          list:[
            'Provide technical knowledge in the design, development, implementation/installation, maintenance, and support of Salesforce application.',
            'Troubleshoot & resolve issues with infrastructure and application.',
            'Provide 24/7 application support as part of a rotating on-call schedule.'
          ]
        },
        {
          label:'Qualifications:',
          list:[
            '3+ years of Salesforce development and/or administration experience',
            'Knowledge on Web service development and integration',
            'Foundational experience with multiple Salesforce cloud solutions primarily focused on Sales and Service Cloud',
            'Experience with Lightning web components',
            'Active Salesforce certifications (PDI/PDII) will be a plus',
            'Experience with Salesforce DX and automated deployment processes',
            'Experience with databases and SQL fundamentals',
            'Willingness to learn and work on different AWS and on-prem applications'
          ]
        }
      ]
    },
    {
      id: 5,
      role: "Salesforce Developer/Architect",
      location: "Remote",
      jd:[
        {
          label:'Job Duties:',
          list:[
            'As a Salesforce developer/architect you will be building and maintaining applications on Client Salesforce org.',
            "The client's Department of Transportation currently uses Salesforce as a key application platform for various Client divisions.",
            'We are looking to expand the power of Salesforce and develop new apps for our business units at the Client.',
            'You will be challenged by a wide variety of projects including legacy database transformation, new custom apps, and more.',
            'We are seeking someone with excellent technical and communication skills who can interface directly with internal stakeholders, understand their needs, configure, and customize the platform to meet new/changing business requirements.',
            'This position will be responsible for ensuring that we are maximizing efficiency and capitalizing on all the features and benefits of the system based on various business needs.',
            "This position will promote adoption, keep current on new releases and AppExchange solutions, and act as the primary contact and a subject matter expert on complex and/or critical system issues and processes for the Client's Salesforce environment."
          ]
        }
      ]
    },
  ];
  export default JobsData;